import { Component } from '@angular/core';
import { environmentCommon } from '../../../../../environments/environment-common';
import { BRAND } from '../../../../data/brand/brand.data';
import { URLS } from '../../../../data/navigation/navigation.data';

/**
 * /store/terms - the Terms of Sale of the premium theme downloads sold on the
 * site (cart → Stripe Checkout → download). Linked from the Checkout
 * consent text, the cart, the order page and the downloads mail. Wording
 * per base-themes/STORE-DESIGN.md §7 (owner decisions: no refunds, prices
 * include VAT, personal licence).
 */
@Component( {
  selector: 'app-store-terms-page',
  templateUrl: './store-terms-page.component.html',
  styleUrls: [ './store-terms-page.component.scss' ],
} )
export class StoreTermsPageComponent {

  BRAND = BRAND;
  URLS = URLS;
  environmentCommon = environmentCommon;

  /** shown under the title; bump when the wording changes */
  readonly lastUpdated = '1 October 2026';
}
